// src/Ontology/ringterminal.js
import React, { useState, useRef, useEffect } from "react";
import "./ringterminal.css";

export default function RingTerminal({ labels, onRename, onReorder, onAdd }) {
  const HOLD_MS = 500;
  const holdTimers = useRef({});
  const holdActivated = useRef({});

  const [contextMenu, setContextMenu] = useState(null);
  const [terminalId, setTerminalId] = useState(null);
  const [renameId, setRenameId] = useState(null);
  const menuRef = useRef(null);

  // 关闭菜单：点击菜单外
  useEffect(() => {
    const handler = e => {
      if (contextMenu && menuRef.current && !menuRef.current.contains(e.target)) {
        setContextMenu(null);
      }
    };
    window.addEventListener("mousedown", handler);
    return () => window.removeEventListener("mousedown", handler);
  }, [contextMenu]);

  // 手势逻辑
  const handleDown = (id, e) => {
    e.stopPropagation();
    holdActivated.current[id] = false;
    const { clientX: x, clientY: y } = e;
    holdTimers.current[id] = setTimeout(() => {
      holdActivated.current[id] = true;
      setContextMenu({ id, x, y });
    }, HOLD_MS);
  };
  const handleUp = (id, e) => {
    e.stopPropagation();
    clearTimeout(holdTimers.current[id]);
    if (!holdActivated.current[id]) {
      setTerminalId(id);
    }
  };
  const handleLeave = id => clearTimeout(holdTimers.current[id]);

  // 从 id 找到 label
  const findLabel = id => {
    const item = labels.find(l => l.id === id);
    return item ? item.label : "";
  };

  // 菜单操作
  const startRename = () => {
    setRenameId(contextMenu.id);
    setContextMenu(null);
  };
  const moveTab = dir => {
    const label = findLabel(contextMenu.id);
    onReorder(label, dir);
    setContextMenu(null);
  };
  const addTab = () => {
    onAdd();
    setContextMenu(null);
  };

  // 提交重命名
  const commitRename = newLabel => {
    const oldLabel = findLabel(renameId);
    onRename(newLabel, oldLabel);
    setRenameId(null);
  };

  return (
    <>
      {/* Labels */}
      <div className="labels-overlay">
        {labels.map(l => (
          <div
            key={l.id}
            className="label"
            style={{ left: l.x, top: l.y }}
            onPointerDown={e => handleDown(l.id, e)}
            onPointerUp={e => handleUp(l.id, e)}
            onPointerLeave={() => handleLeave(l.id)}
          >
            {l.label}
          </div>
        ))}
      </div>

      {/* Context Menu */}
      {contextMenu && (
        <div
          ref={menuRef}
          className="ring-context-menu"
          style={{ left: contextMenu.x, top: contextMenu.y }}
        >
          <div className="context-item" onClick={startRename}>
            Rename Tab
          </div>
          <div className="context-item" onClick={() => moveTab("up")}>
            Move Tab Up
          </div>
          <div className="context-item" onClick={() => moveTab("down")}>
            Move Tab Down
          </div>
          <div className="context-item" onClick={addTab}>
            Add a New Tab
          </div>
        </div>
      )}

      {/* Terminal Window */}
      {terminalId && (
        <div className="editor-overlay terminal-window">
          <div className="terminal-header">
            <span>Terminal: {findLabel(terminalId)}</span>
            <button onClick={() => setTerminalId(null)}>✕</button>
          </div>
          <textarea
            className="terminal-textarea"
            placeholder="Enter prompt, text, or code. Or drag and drop any files."
          />
        </div>
      )}

      {/* Rename Prompt */}
      {renameId && (
        <div className="editor-overlay rename-window">
          <strong>Rename Tab</strong>
          <input
            type="text"
            defaultValue={findLabel(renameId)}
            onKeyDown={e => e.key === "Enter" && commitRename(e.target.value)}
            autoFocus
          />
          <div className="rename-actions">
            <button onClick={() => commitRename(
              document.querySelector(".rename-window input").value
            )}>
              Save
            </button>
            <button onClick={() => setRenameId(null)}>Cancel</button>
          </div>
        </div>
      )}
    </>
  );
}
